import { DBDef_FAQ } from '@app/advisor-ui-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_FAQ } from '../../_entity/frequently-asked-question/ModuleFE_FAQ.js';
import { Manager_FAQ } from '../../ui/_managers/Manager_FAQ/Manager_FAQ.js';
import { ConfigDialogKeys_AdvisorUI, ConfigDialogs_AdvisorUI_Dialogs, ConfigDialogs_AdvisorUI_Labels } from '../../ui/config-dialogs/index.js';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_FAQ,
    dbDef: DBDef_FAQ,
    tag: ['Fq', 'FAQ'],
    modulesToAwait: [ModuleFE_FAQ],
    ManagerComponent: Manager_FAQ,
    extraMenuSections: () => [{
            actions: ConfigDialogKeys_AdvisorUI.map(key => ({
                label: ConfigDialogs_AdvisorUI_Labels[key],
                action: () => ConfigDialogs_AdvisorUI_Dialogs[key].show(),
            })),
        }],
    resultSubtitle: (faq) => faq?.type,
});
export const WorkHubItem_FAQ = WorkHubItem;
export const UtilObject_FAQ = UtilObject;
export const SearchItem_FAQ = SearchItem;
//# sourceMappingURL=faq.js.map